import { render, staticRenderFns } from "./crudZones.vue?vue&type=template&id=143148ee&scoped=true&"
import script from "./crudZones.vue?vue&type=script&lang=js&"
export * from "./crudZones.vue?vue&type=script&lang=js&"
import style0 from "./crudZones.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudZones.vue?vue&type=style&index=1&id=143148ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143148ee",
  null
  
)

export default component.exports